import { Navigate } from "react-router-dom";

import { useAuth } from "@/lib/auth";
import { mustSetPassword } from "@/types/auth";

const DASHBOARD_PATH = "/dashboard";
const LOGIN_PATH = "/login";

function AuthLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-whart-bg text-sm text-neutral-500">
      Chargement…
    </div>
  );
}

export function AuthRedirect() {
  const { user, isLoading, isStaff } = useAuth();

  if (isLoading) {
    return <AuthLoading />;
  }

  if (user && isStaff) {
    if (mustSetPassword()) {
      return <Navigate to="/set-password" replace />;
    }

    return <Navigate to={DASHBOARD_PATH} replace />;
  }

  return <Navigate to={LOGIN_PATH} replace />;
}
